import "magnific-popup";

export function popupVideo() {
  if ($('.play-video')[0]) {
    $('.play-video').magnificPopup({
      disableOn: 0,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 600,
      preloader: false,
      fixedContentPos: true
    });
  }
}